export default "__VITE_ASSET__CxmEv53$__"